import { getCssVar } from "./helpers";
import client from '../../../vendor/rshop/frontend/assets/js/common/client'

const $ = window.jQuery;
const lang = document.querySelector('html').getAttribute('lang')
let generalError

import(`../locale/${lang}.json`).then((module) => {
    generalError = module.GeneralError
})

export function buildStars() {
    for (const starElement of document.querySelectorAll('.js-stars')) {
        if (starElement.classList.contains('is-loaded')) {
            continue
        }

        const updateInput = starElement.dataset.updateInput
        const emptyColor = starElement.dataset.emptyColor || '#E9E9E9'
        const readOnly = !updateInput

        let settings = {
            starSize: starElement.dataset.size || 20,
            initialRating: starElement.dataset.stars * 5 / 100,
            readOnly: readOnly,
            emptyColor: emptyColor,
            hoverColor: getCssVar('--c-primary'),
            activeColor: getCssVar('--c-primary'),
            ratedColor: getCssVar('--c-primary'),
            strokeColor: 'transparent',
            useGradient: false,
            disableAfterRate: false
        }

        if (updateInput) {
            settings.callback = (currentRating, el) => {
                document.querySelector(updateInput).value = currentRating
            }
        }

        $(starElement).starRating(settings)
        starElement.classList.add('is-loaded')
    }
}

export function initRatingForm() {
    $('.js-product-rating-form').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]').addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(() => {
                window.Form.ajaxPost(form, function(data) {
                    $('.js-product-rating-message').slideUp(100);

                    if (data.status) {
                        $('.js-product-rating-form').slideUp();
                    }

                    $('.js-product-rating-message')
                        .toggleClass('c-msg--error', !data.status)
                        .toggleClass('c-msg--success', data.status)
                        .text(data.message)
                        .slideDown();

                    $(form).find('[type="submit"]').removeClass('is-loading');
                }, 'json');
            });
        }
    });
}

function updateRatedItems() {
    const ratedItems = JSON.parse(window.localStorage.getItem('user-rated-items'))

    if (ratedItems) {
        for (const ratedItem of ratedItems) {
            for (const ratedEl of document.querySelectorAll(`.js-useful-trigger[data-id="${ratedItem.id}"]`)) {
                ratedEl.setAttribute('disabled', true)

                if (ratedEl.dataset.value == ratedItem.value) {
                    ratedEl.classList.add('is-selected')
                }
            }
        }
    }
}

function updateRatedItemsStorage(id, value) {
    let ratedItems = JSON.parse(window.localStorage.getItem('user-rated-items'))

    if (!ratedItems) {
        ratedItems = []
    }

    ratedItems.push({
        id: id,
        value: value
    })

    window.localStorage.setItem('user-rated-items', JSON.stringify(ratedItems))
}

export function initUsefulRatingVote() {
    updateRatedItems()

    for (const usefulTrigger of document.querySelectorAll(`.js-useful-trigger`)) {
        usefulTrigger.addEventListener('click', (event) => {
            const triggeredEl = event.currentTarget
            const productId = triggeredEl.dataset.productId
            const id = triggeredEl.dataset.id
            const value = triggeredEl.dataset.value

            triggeredEl.classList.add('is-loading')
            triggeredEl.setAttribute('disabled', true)

            grecaptcha.execute(window.recaptchaSiteKey, {action: 'rating_useful'}).then(function(token) {
                client
                    .post(`/uzitocne-hodnotenie`, {
                        product_id: productId,
                        rating_id: id,
                        is_useful: value == 'yes',
                        captcha_token: token
                    })
                    .then((response) => {
                        const data = response.data

                        if (data.status) {
                            updateRatedItemsStorage(id, value)
                            updateRatedItems()

                            const countEl = triggeredEl.querySelector('.is-count')

                            countEl.innerText = parseInt(countEl.innerText) + 1
                        } else {
                            triggeredEl.removeAttribute('disabled')
                        }

                        triggeredEl.classList.remove('is-loading')

                        window.Eshop.tippyAlert(triggeredEl.parentElement, data.msg, {
                            theme: data.status ? 'success' : 'error'
                        });
                    })
                    .catch((error) => {
                        window.Eshop.tippyAlert(triggeredEl.parentElement, generalError, {
                            theme: 'error'
                        });
                        triggeredEl.classList.remove('is-loading')
                        triggeredEl.removeAttribute('disabled')
                    })
            });
        })
    }
}
